export default __webpack_public_path__ + "static/media/mTT.fb0b332c.png";